import { Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ADMIN_ROUTES } from "@/shared/constants/paths";

import StyleGuideLayout from "@/pages/layouts/StyleGuideLayout";
import StyleGuideIndexPage from "@/pages/admin/style-guide/StyleGuideIndexPage";
import FoundationPage from "@/pages/admin/style-guide/foundation/FoundationPage";
import FormControlsPage from "@/pages/admin/style-guide/form-controls/FormControlsPage";
import DataDisplayPage from "@/pages/admin/style-guide/data-display/DataDisplayPage";
import FeedbackPage from "@/pages/admin/style-guide/feedback/FeedbackPage";
import LayoutPage from "@/pages/admin/style-guide/layout/LayoutPage";
import OverlaysPage from "@/pages/admin/style-guide/overlays/OverlaysPage";
import CustomPage from "@/pages/admin/style-guide/custom/CustomPage";
import { UploadPage } from "@/pages/admin/style-guide/upload/UploadPage";
import AuthPage from "@/pages/admin/style-guide/auth/AuthPage";
import IntegrationsPage from "@/pages/admin/style-guide/integrations/IntegrationsPage";

export const styleGuideRoutes = (
  <Route
    path={ADMIN_ROUTES.STYLE_GUIDE}
    element={
      <>
        <Helmet>
          <title>Style Guide - Elayne Admin</title>
        </Helmet>
        <StyleGuideLayout />
      </>
    }
  >
    <Route index element={<StyleGuideIndexPage />} />
    <Route path="foundation" element={<FoundationPage />} />
    <Route path="form-controls" element={<FormControlsPage />} />
    <Route path="data-display" element={<DataDisplayPage />} />
    <Route path="feedback" element={<FeedbackPage />} />
    <Route path="layout" element={<LayoutPage />} />
    <Route path="overlays" element={<OverlaysPage />} />
    <Route path="custom" element={<CustomPage />} />
    <Route path="upload" element={<UploadPage />} />
    <Route path="auth" element={<AuthPage />} />
    <Route path="integrations" element={<IntegrationsPage />} />
  </Route>
);
